import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ModuleLevelGuard  {
  public moduleConfigs: any

  constructor(private router: Router) {
    this.moduleConfigs = environment.moduleConfigs
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    switch (state.url) {
      case '/dashboard':
        if (this.moduleConfigs.dashboardModule.isActive) {
          return true
        }

        return this.router.parseUrl(
          this.moduleConfigs.authModule.afterLoginSuccessRedirect
        )

      default:
        return true
    }
  }
}
